import React, { Fragment } from 'react';
import moment from 'moment';
import withStyles from '@mui/styles/withStyles';
import { compose } from '../../reactApolloCompat';
import { withRouter } from '../../utils/withRouter';
import Hidden from '../../components/Hidden';
import CalendarFilters from './CalendarFilters';
import { withEditAppointment } from '../../context/EditAppointment';
import NextIcon from '../../components/icon/NextIcon';
import BackIcon from '../../components/icon/BackIcon';
import FlexGrid from '../../components/layout/FlexGrid';
import DatePickerField from '../../components/form/DatePickerField';
import { CalendarIcon } from '../../components/IconIndex';
import { titleCase } from '../../utils/strings';

class DayToolbar extends React.Component {
    state = {
        date: this.props.date
    };

    static getDerivedStateFromProps({ date: newDate }, { date: oldDate }) {
        if (!newDate.isSame(oldDate)) return { date: newDate };
        return null;
    }

    render() {
        const { classes } = this.props;
        return (
            <div className={classes.padToolbar}>
                <Hidden smDown>
                    <div className="rbc-toolbar print-hide">
                        <span className="rbc-btn-group">{this.renderTypeSwitcher()}</span>
                        <span className="rbc-btn-group">{this.renderCalendarNavigationNative()}</span>
                        {this.renderFilters()}
                    </div>
                </Hidden>
                <Hidden smUp>
                    <div className="rbc-toolbar toolbar-2 print-hide">
                        <span className="rbc-btn-group calWidth" style={{ display: 'flex' }}>
                            {this.renderTypeSwitcher()}
                            {this.renderCalendarNavigationNative()}
                            {this.renderFilters()}
                        </span>
                    </div>
                </Hidden>
                <div className="print-show">
                    <h2>{this.showHeading()}</h2>
                </div>
            </div>
        );
    }

    renderTypeSwitcher() {
        const { props } = this;
        let viewNames = props.views;
        let view = props.view;
        let result = false;
        if (viewNames.length > 1) {
            result = viewNames.map(name => {
                return (
                    <button
                        type="button"
                        key={name}
                        className={view === name ? 'rbc-active' : ''}
                        onClick={() => this.view(name)}
                    >
                            <span>
                                <small style={{
                                    position: 'absolute',
                                    marginTop: 7,
                                    display: 'block',
                                    width: 21,
                                    textAlign: 'center'
                                }}>{Array.from(name)[0]}</small>
                                <CalendarIcon />
                                <Hidden mdDown>{titleCase(name)}</Hidden>
                            </span>
                    </button>
                );
            });
        }
        return result;
    }

    showHeading() {
        const { view, label } = this.props;
        const { date } = this.state;
        return view === 'Locations' ? label : moment(date).format('ddd, D MMM YYYY');
    }

    renderCalendarNavigationNative() {
        const { classes } = this.props;
        const { date } = this.state;
        const isToday = moment(date).isSame(new Date(), 'day');
        const { onNavigate } = this.props;
        return (
            <Fragment>
                <Hidden smDown>
                    <button type="button" onClick={this.navigate('PREV')} className="arrowBtn">
                        <BackIcon />
                    </button>
                </Hidden>
                <button
                    type="button"
                    onClick={this.navigate('TODAY')}
                    className={isToday ? 'rbc-active today' : 'today'}
                >
                    {!isToday ? (
                        <small>
                            Go to
                            <br />
                            Today
                        </small>
                    ) : (
                        <>Today</>
                    )}
                </button>
                <button type="button" className="day" style={{ padding: 0, flex: 2 }}>
                    <FlexGrid nowrap>
                        <Hidden mdDown>
                            <span style={{ paddingLeft: 24, marginRight: -24 }}>{moment(date).format('dddd')},</span>
                        </Hidden>
                        <DatePickerField
                            InputProps={{ classes: { root: classes.noBorder } }}
                            value={moment(date).format('YYYY-MM-DD')}
                            onChange={evt => onNavigate('DATE', moment(evt.target.value).toDate())}
                        />
                    </FlexGrid>
                </button>
                <Hidden smDown>
                    <button type="button" onClick={this.navigate('NEXT')} className="arrowBtn">
                        <NextIcon />
                    </button>
                </Hidden>
            </Fragment>
        );
    }

    renderFilters() {
        const { props } = this;
        return (
            <CalendarFilters
                setFilters={props.setFilters}
                filters={props.filters}
                view={props.view}
                resources={props.getResources()}
                groups={props.getGroups()}
            />
        );
    }


    navigate = action => e => {
        e.preventDefault();
        const { onNavigate } = this.props;
        onNavigate(action);
    };

    view = view => {
        const { onView } = this.props;
        onView(view);
    };
}

const styles = ({ spacing, breakpoints, palette }) => ({
    container: {
        display: 'flex',
        flexDirection: 'column'
    },
    padToolbar: {
        marginBottom: spacing(1),
        [breakpoints.down('sm')]: {
            marginBottom: spacing(0.5)
        }
    },
    pageTitle: {
        color: palette.primary.text,
        display: 'flex',
        alignItems: 'center'
    },
    popover: {
        padding: '0.1rem 1.5rem 1.5rem',
        width: '400px',
        maxWidth: '100%',
        fontSize: '90%',
        backgroundColor: '#fafafa'
    },
    bulkbuttons: {
        border: '1px solid #35327c',
        borderRadius: '5rem',
        fontSize: '75%',
        backgroundColor: 'white',
        marginRight: '0.5rem',
        color: '#35327c',
        textTransform: 'none'
    },
    icons: {
        fontSize: '18px',
        margin: '-4px 0'
    },
    padRight: {
        marginRight: '10px'
    },
    noBorder: {
        border: 0,
        padding: '0 0.88rem',
        marginTop: '0 !important',
        '& > input': {
            padding: '6px 0 7px',
            boxSizing: 'content-box',
            height: '1.1875em'
        }
    }
});

export default compose(withRouter, withEditAppointment, withStyles(styles))(DayToolbar);
